import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Plus } from "lucide-react";
import { api } from "../../api";
import { APageHead, ATable, ABadge, AMetric } from "../adminKit";

export default function AdminFunding() {
  const [d, setD] = useState({ programs: [], assessments: 0, disclaimer: "" });
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ name: "", provider: "", funding_type: "", min_time_in_business: "", min_revenue: "", status: "active" });
  const load = () => api.get("/admin/funding").then(({ data }) => setD(data));
  useEffect(() => { load(); }, []);
  const create = async () => {
    if (!form.name.trim()) return toast.error("Name required");
    try { await api.post("/admin/funding", form); setOpen(false); toast.success("Program added"); load(); } catch { toast.error("Failed"); }
  };
  return (
    <div className="space-y-4">
      <APageHead title="Funding Readiness Administration" subtitle="Aggregate readiness data and the funding-program directory."
        action={<button onClick={() => setOpen(true)} className="cc-btn-primary inline-flex items-center gap-2 rounded-xl px-4 py-2 text-sm font-500" data-testid="program-new"><Plus size={15} /> Add Program</button>} />
      <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
        <AMetric label="Assessments Completed" value={d.assessments} tone="blue" />
        <AMetric label="Funding Programs" value={d.programs.length} tone="purple" />
        <AMetric label="Active Programs" value={d.programs.filter((p) => p.status === "active").length} tone="green" />
      </div>
      <div className="rounded-xl border border-amber-500/20 bg-amber-500/[0.06] px-4 py-2.5 text-xs text-amber-200/80">{d.disclaimer}</div>
      <ATable loading={false} rows={d.programs} columns={[
        { key: "name", label: "Program", render: (r) => <span className="text-white">{r.name}</span> },
        { key: "provider", label: "Provider" },
        { key: "funding_type", label: "Type" },
        { key: "min_time_in_business", label: "Min TIB" },
        { key: "status", label: "Status", render: (r) => <ABadge tone={r.status === "active" ? "green" : "default"}>{r.status}</ABadge> },
      ]} empty="No funding programs yet." />
      {open && (
        <div className="fixed inset-0 z-[60] flex items-center justify-center px-4">
          <div className="absolute inset-0 bg-black/60" onClick={() => setOpen(false)} />
          <div className="relative cc-card rounded-2xl p-6 w-full max-w-md space-y-3">
            <h3 className="cc-heading text-lg font-500 text-white">Add Funding Program</h3>
            <input placeholder="Program name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="cc-input w-full rounded-xl px-4 py-2.5 text-sm" data-testid="program-name" />
            <div className="grid grid-cols-2 gap-3">
              <input placeholder="Provider" value={form.provider} onChange={(e) => setForm({ ...form, provider: e.target.value })} className="cc-input rounded-xl px-3 py-2.5 text-sm" />
              <input placeholder="Funding type" value={form.funding_type} onChange={(e) => setForm({ ...form, funding_type: e.target.value })} className="cc-input rounded-xl px-3 py-2.5 text-sm" />
            </div>
            <div className="grid grid-cols-2 gap-3">
              <input placeholder="Min time in business" value={form.min_time_in_business} onChange={(e) => setForm({ ...form, min_time_in_business: e.target.value })} className="cc-input rounded-xl px-3 py-2.5 text-sm" />
              <input placeholder="Min revenue" value={form.min_revenue} onChange={(e) => setForm({ ...form, min_revenue: e.target.value })} className="cc-input rounded-xl px-3 py-2.5 text-sm" />
            </div>
            <button onClick={create} className="cc-btn-primary w-full rounded-xl py-2.5 text-sm font-500" data-testid="program-create">Add Program</button>
          </div>
        </div>
      )}
    </div>
  );
}
